import React from 'react';
import { t } from '@sm/intl';
import { DetailsFeatureRowPackages } from '~pricing/lib/summaryPackages';
import PackageDefs from '~pricing/components/Summary/packageDefs';

import useCategoryStyles from './useStyles';
import COPY from './copy';

export default function FeatureCell(pkg: DetailsFeatureRowPackages): JSX.Element {
  const { Cell, Bullet, BulletInverse, Highlighted } = useCategoryStyles({ packageName: pkg.packageName });
  let a11yValue = t(COPY.UNAVAILABLE);

  if (typeof pkg.value === 'string') {
    a11yValue = pkg.value;
  } else if (pkg.value) {
    a11yValue = t(COPY.AVAILABLE);
  }

  return (
    <div
      role="cell"
      aria-label={`${pkg.packageName} ${a11yValue}`}
      className={`${Cell} ${PackageDefs[pkg.packageName].highlighted ? Highlighted : ''}`}
      tabIndex={-1}
      data-testid="FeatureCell"
    >
      {typeof pkg.value === 'string'
        ? pkg.value
        : pkg.value && <span className={PackageDefs[pkg.packageName].highlighted ? BulletInverse : Bullet} />}
    </div>
  );
}
